import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { PlusCircleIcon } from '@heroicons/react/24/outline'
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/20/solid'
import { ChevronRightIcon } from '@heroicons/react/20/solid'
import { useGetExercises } from 'redux/customHooks/useGetExercises'

import ExerciseImage from 'components/ExerciseImage'

// Exercise search and list. Used by ExerciseLibraryModal and inside modals that can't open another modal (ModalContext shows one at a time)

export default function ExerciseLibraryList({
    OnExerciseSelected = () => {},
    listHeightClassName = 'h-[70vh]',
    className = ''
}) {
    const { exercises } = useGetExercises()

    const organizationId = useSelector(state => state.user.organizationId)

    const [exerciseSearchTerm, setExerciseSearchTerm] = useState('')
    const [filteredExercises, setFilteredExercises] = useState(exercises.filter(exercise => exercise.name.toLowerCase().includes(exerciseSearchTerm.toLowerCase())).sort((a, b) => a.name.localeCompare(b.name)))

    useEffect(() => {
        setFilteredExercises(exercises.filter(exercise => exercise.name.toLowerCase().includes(exerciseSearchTerm.toLowerCase())).sort((a, b) => a.name.localeCompare(b.name)))
    }, [exercises, exerciseSearchTerm])

    return (
        <div className={`space-y-4 ${className}`}>
            <div className="flex items-center gap-x-2">
                <div className="flex-grow relative">
                    <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                        <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                    </div>

                    <input
                        type="text"
                        className="w-full py-2 pl-10 pr-16 rounded-md border border-gray-400 bg-white placeholder-gray-500 focus:border-orange-400 focus:outline-none focus:ring-1 focus:ring-orange-400"
                        placeholder={'Enter Exercise Name'}
                        value={exerciseSearchTerm}
                        onChange={(event) => setExerciseSearchTerm(event.target.value)}
                    />

                    {exerciseSearchTerm && (
                        <div 
                            className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer" 
                            onClick={() => setExerciseSearchTerm('')}
                        >
                            <XMarkIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                        </div>
                    )}
                </div>

                {/* Only create exercise button for Kinesis internal org */}
                {organizationId === 1 && (
                    <div 
                        className='cursor-pointer' 
                        // onClick={() => setModalRoute('exercise-create')}
                    >
                        <PlusCircleIcon className='w-8 h-8 text-gray-400' />
                    </div>
                )}
            </div>

            <div className={`border border-gray-400 rounded-lg ${listHeightClassName} overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] space-y-4`}>
                <div className='divide-y divide-gray-400 overflow-hidden'>
                    {filteredExercises.length === 0 && (
                        <div className='p-2 text-gray-400'>No exercises found</div>
                    )}

                    {filteredExercises.length > 0 && filteredExercises.filter(exercise => exercise.archived === 0).map((exercise, index) => (
                        <div 
                            key={index} 
                            className='flex items-center gap-x-4 p-2 cursor-pointer hover:bg-gray-100'
                            onClick={() => OnExerciseSelected(exercise)}
                        >
                            <ExerciseImage
                                exercise={exercise}
                                exercises={exercises}
                            />

                            <div className='text-left'>{exercise.name}</div>

                            <div className='flex-1'/>

                            <ChevronRightIcon className='w-8 h-8 text-gray-400' />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
